<template>
  <div>
    <form action="" @submit.prevent="handleSubmit()" class="tdesk-form">
      <div class="form-group">
        <label for="voucher_code">Apply voucher (optional)</label>
        <div v-if="totalAtZero">
          <div
              v-tooltip:top="'You cannot add any more vouchers as the total has reached 0'"
              tabindex="0" style="position: relative; display: inline-block;"
              data-toggle="tooltip" class="tdesk-tooltip">
            <div
                style="position:absolute;height: 100%;width:100%; cursor:not-allowed"></div>
            <div
                style="display: inline-flex;justify-content: space-between; width: 100%;">
              <input type="text"
                     style="margin-right: 17px;"
                     disabled>
              <button type='submit'
                      class="tdesk-secondary-button"
                      disabled>
                Apply
              </button>
            </div>
          </div>
        </div>
        <div v-else-if="voucherNotCombinable">
          <div
              v-tooltip:top="'An existing voucher is preventing more from being added'"
              tabindex="0" style="position: relative; display: inline-block;"
              data-toggle="tooltip" class="tdesk-tooltip">
            <div
                style="position:absolute;height: 100%;width:100%; cursor:not-allowed"></div>
            <div
                style="display: inline-flex;justify-content: space-between; width: 100%;">
              <input type="text"
                     style="margin-right: 17px;"
                     disabled>
              <button type='submit'
                      class="tdesk-secondary-button"
                      disabled>
                Apply
              </button>
            </div>
          </div>
        </div>
        <div
            style="display: inline-flex;justify-content: space-between; width: 100%;"
            v-else>
          <input type="text"
                 id="voucher_code"
                 style="margin-right: 17px;"
                 v-model="voucherCode">
          <button type='submit'
                  class="tdesk-secondary-button"
                  id="apply">
            Apply
          </button>
        </div>
      </div>
      <div id="form-errors" class="form-errors">
        <form-errors :errors="errors"></form-errors>
        <notice :type="'success'" :message="successMessage"
                v-if="successMessage"></notice>
      </div>
    </form>
    <div v-if="appliedVouchers.length > 0">
      <div class="tdesk-secondary-box-container"
           v-for="voucher in appliedVouchers" :key="voucher.id"
           style="margin-bottom: 19px; display: inline-flex; width: 100%; justify-content: space-between;">
        <div>
          <div class="tdesk-body--small">
            Voucher applied
          </div>
          <div class="tdesk-body--small tdesk-secondary-active">
            {{voucher.code}}
          </div>
        </div>
        <div>
          <div class="tdesk-utility-button" @click="removeVoucher(voucher.id)">
            <i class="fas fa-trash"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import FormErrors from '../../form_errors';
  import Notice from '../../tdesk_notice';

  export default {
    components: {FormErrors, Notice},
    props: {
      total: {
        required: true,
        type: Number
      },
      clientId: {
        required: false,
        type: Number
      },
      courseId: {
        required: true,
        type: Number
      },
      numberOfParticipants: {
        required: true,
        type: Number
      },
      appliedVouchers: {
        required: true,
        type: Array
      }
    },
    data() {
      return {
        voucherCode: null,
        errors: [],
        successMessage: null,
        vouchers: this.appliedVouchers
      };
    },
    computed: {
      totalAtZero() {
        return this.total < 1;
      },
      voucherNotCombinable() {
        if (this.vouchers.find(v => !v.combinable)) return true;
      }
    },
    watch: {
      voucherCode: function (val) {
        if (val) {
          this.voucherCode = val.replace(/\s/g, '');
        }
      }
    },
    methods: {
      handleSubmit() {
        this.applyVoucher();
      },
      canAddToOrder(voucher) {
        if (this.totalAtZero) {
          return;
        }
        let appliedVoucherIds = this.vouchers.map(appliedVoucher => appliedVoucher.id);
        if (appliedVoucherIds.includes(voucher.id)) {
          this.errors = ["You've already added this voucher"];
          return false;
        }
        return true;
      },
      addToVouchers(voucher) {
        if (!voucher.combinable && this.vouchers.length > 0) {
          this.addToErrors(['This voucher cannot be added while others are in use']);
          return this.removeVoucher(voucher.id);
        }
        if (!this.canAddToOrder(voucher)) {
          return;
        }
        this.voucherCode = null;
        this.errors = [];
        this.vouchers.push(voucher);
        this.$emit('apply-vouchers', this.vouchers);
        this.successMessage = 'Voucher applied successfully';
        setTimeout(() => this.successMessage = null, 2500);
      },
      applyVoucher() {
        const data = {
          code: this.voucherCode,
          session_unit_id: this.courseId,
          total_value_of_order: this.total,
          number_of_participants: this.numberOfParticipants,
          client_id: this.clientId
        };
        axios
            .post(Routes.apply_voucher_path(data))
            .then(rsp => this.addToVouchers(rsp.data))
            .catch(err => this.addToErrors(err.response.data));
      },
      removeVoucher(voucherId) {
        this.vouchers = this.vouchers.filter(v => v.id !== voucherId);
        this.$emit('remove-voucher', voucherId);
      },
      addToErrors(errors) {
        this.errors = errors;
      }
    }
  };
</script>
